import React from 'react';
import CopyButton from 'flow/components/pbx/v2/misc/CopyButton';
import useAppContext from 'flow/hooks/useAppContext';
import { TicketKey } from 'flow/types/EntityKeys';
import { getTicketIdUiFriendly } from 'flow/utils/ticket-utils';

interface Props {
    ticketKey: TicketKey;
}

const TicketIdInfoItem = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();

    const ticketId = getTicketIdUiFriendly(ticketKey);
    if (!ticketId) return null;

    return (
        <div>
            <div className="mb-2 text-xs font-bold text-black">
                {i18next.t('ticket.id')}
            </div>
            <div className="flex h-10 items-center justify-between rounded-sm bg-gray-200 ps-3 pe-1 text-sm">
                <span>{ticketId}</span>
                <CopyButton
                    text={ticketId}
                    tooltipLabel={i18next.t('ticket.id.copy')}
                />
            </div>
        </div>
    );
};

export default React.memo(TicketIdInfoItem);
